import { EntityBase } from "./entityBase";
import { Product } from "./product";

export class Category extends EntityBase {
    public Name: string = '';
    public ParentCategoryId?: number | undefined;
    public ParentCategory: Category | undefined;
    public Products: Array<Product> = [];
    public Categories: Array<Category> = [];
}